export default __webpack_public_path__ + "static/media/lotte-cinema.08167da6.png";